angular.module('impactx.search').component('ixThemeworldItem', {
        bindings: {
            themeworld: '<',
            trns: '<'
        },
        controller: 'ThemeworldItemCtrl',
        templateUrl: 'modules/search/templates/themeworld-item.html'
    }
);
